<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <filter-manager
      :display-advanced="false"
      class="search-bar"
      search-icon="fa fa-sync"
      search-text="Procesar"
      search-container-class="btn-process"
      v-model="model.search.filters"
      :filters="filterManagerConfig"
      @search="onHandlerSearch"
      @center="onChangeServiceCenter"
      ref="filterRef"
    />
    <custom-separator class="mt-1 mb-4" text="Resultado de Referido" />

    <custom-result-not-found
      :text="'No hay información disponible.'"
    />

    
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import AcademicYearServices from '@/services/api/academicyear.api';
import LocationServices from '@/services/api/location.api';
import ReportServices from '@/services/api/report.api';
import CustomSeparator from "custom-separator";
import CustomResultNotFound from "custom-result-not-found";
import DocumentServices from '@//modules/report/document'

export default {
  name: 'OnlinePreRegistrationMain',
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
  },
  data: () => ({
    model: {
      search: {
        collections: {
          academicYears: [],
          centers: [],
          healthRegions:[],
        },
        filters: {
          academicYear: null,
          center: null,
          healthRegion:null
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Referidos Parte C a Parte B',
        icon: 'fas fa-file-invoice pr-0 font-22 magnifying-glass-icon-m ',
        routes: ['Inicio', 'Referidos Parte C a Parte B'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          placeholder: 'Año académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-4',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'CSEE',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          class: 'col-12 col-md-4',
          validations: null,
        },
        {
          name: 'healthRegion',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Región de Salud',
          options: this.model.search.collections.healthRegions,
          value: this.model.search.filters.healthRegion,
          class: 'col-12 col-md-4',
          validations: null,
        },
      ];
    },
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async onChangeAcademicYear() {
      await this.getCenters();
    },
    async setFilters() {
      const {
        data: years,
      } = await AcademicYearServices.getCurrentYearAcademicYears();
      this.model.search.collections.academicYears = [...years];
      this.model.search.filters.academicYear = years[0];
      await this.getCenters();
      await this.onChangeServiceCenter();
    },
    async getCenters() {
      await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear.id,
      }).then((res) => {
        this.model.search.collections.centers = res.data;
      });
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        await this.process();
      }
    },
    async onChangeServiceCenter() {
      const payload = {
        centerId: this.model?.search?.filters?.center?.id
      };
      const { data } = await LocationServices.getHealthRegions(payload);
      this.model.search.collections.healthRegions = data;
      this.model.search.filters.healthRegion = null;
    },
    async process() {
      const filters = {
        academicYearId:this.model?.search.filters?.academicYear?.id,
        centerId:this.model?.search?.filters?.center?.id,
        regionId:this.model?.search.filters?.healthRegion?.id
      }
      const { data } =await ReportServices.getReferralsFromPartCToPartB(filters)
      DocumentServices.Download(data);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .btn-process {
  bottom: -1px !important;
  right: 15px !important;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}
</style>
